<template>
  <div class="header-container">
    <AppTitle />
    <div class="top-right">
      <LanguageSwitcher />
      <UserBadge class="badge" />
    </div>
    
  </div>
</template>

<script>
import AppTitle from '@/components/header_bar_components/AppTitle.vue';
import UserBadge from '@/components/header_bar_components/UserBadge.vue';
import LanguageSwitcher from './LanguageSwitcher.vue';

export default {
  components: {
    AppTitle,
    LanguageSwitcher,
    UserBadge
  }
};
</script>

<style scoped>

.header-container {
  display: flex;
  height: 50px;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.top-right {
  display: flex;
  justify-content: space-between;
  width: 200px;
}
.badge {
  margin-right: 10px;
}
</style>